import React, { useState, useEffect, useMemo } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';
import funcionCambioURL from '../../../../funciones/gestionURL';
import Tooltip from '@mui/material/Tooltip';

// `sx` (opcional, 31/10): se AÑADE encima del estilo de siempre. Sin él, el buscador es igual que
// antes —220px en escritorio— en las diez tablas que lo usan; el listado de Personas lo pide
// elástico para que encoja antes de que su barra salte de línea.
// `size` (opcional, 31/10): el de MUI; sin él, el de siempre. Ver la nota en SelectDinamicoLista.
const Buscador = ({ placeholder,tooltip, palabra, setEstadoBusqueda, escribiendo, setEscribiendo, sx, size }) => {
  const navigate = useNavigate();
  const [palabraIntroducida, setPalabraIntroducida] = useState(palabra || '');
  /* UNA SOLA, NO UNA POR PINTADO (16/10). `funcionCambioURL` devuelve una función nueva en cada
   * llamada, y `cambioURL` está en las dependencias de la espera de 1 s de abajo: cada repintado la
   * cancelaba y la volvía a empezar. La pantalla de personas con el candado abierto se repinta cada
   * segundo —lleva el contador—, así que la espera se reiniciaba al ritmo al que vencía, y la
   * búsqueda salía o no según unos milisegundos («a veces no busca», Bryan). Memorizarla es seguro:
   * lee `window.location` al llamarla, no al crearla. */
  const cambioURL = useMemo(() => funcionCambioURL('busqueda'), []);
  const [estaEscribiendo, setEstaEscribiendo] = useState(false);

  useEffect(() => {
    if (!estaEscribiendo && palabra !== palabraIntroducida) {
      setPalabraIntroducida(palabra || '');
      if (!palabra || palabra === '') {
        setEstadoBusqueda(false);
        setEscribiendo(false);
      } else {
        setEstadoBusqueda(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [palabra, estaEscribiendo]);

  const cambioDelImput = (event) => {
    const newValue = event.target.value;
    setEstaEscribiendo(true);
    setPalabraIntroducida(newValue);
    comprobarBusqueda(newValue);
  };

  const comprobarBusqueda = (busqueda) => {
    if (!busqueda || busqueda === '') {
      setEstadoBusqueda(false);
      setEscribiendo(false);
      setEstaEscribiendo(false);
      setPalabraIntroducida('');
      const nuevaURL = cambioURL(''); 
      navigate(nuevaURL);
    } else {
      setEstadoBusqueda(true);
      setEscribiendo(true);
    }
  };

  useEffect(() => {
    let timeout;
    if (escribiendo && estaEscribiendo) {
      timeout = setTimeout(() => {
        const nuevaURL = cambioURL(palabraIntroducida);
        navigate(nuevaURL);
        setEstaEscribiendo(false);
      }, 1000);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [palabraIntroducida, escribiendo, navigate, cambioURL, estaEscribiendo]);

  const limpiarInput = () => {
    setEstadoBusqueda(false);
    setEscribiendo(false);
    setPalabraIntroducida('');
    const nuevaURL = cambioURL('');
    navigate(nuevaURL);
  };

  return (
    <Stack 
      spacing={4} 
      sx={{
        width: { xs: '100%', sm: 220 },
        ml: { xs: 0, sm: 0.5 },
        mb: { xs: 1, sm: 0 },
        ...sx
      }}
    >
      <Tooltip title={tooltip}>
      <TextField
        label={placeholder}
        variant="outlined"
        size={size}
        value={palabraIntroducida}
        onChange={cambioDelImput}
        fullWidth
        InputProps={{
          endAdornment: (
            <>
              {palabraIntroducida.length > 0 && (
                <ClearIcon style={{ cursor: 'pointer', fontSize: '20px' }} onClick={limpiarInput} />
              )}
            </>
          ),
        }}
      />
      </Tooltip>
    </Stack>
    
  );
};

export default Buscador;
